import React, { Fragment } from "react";
import { Box, Avatar, Typography, Divider } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  avatar: {
    width: theme.spacing(5),
    height: theme.spacing(5)
  }
}));

export default function LeadersList({ leaders }) {
  const classes = useStyles();
  return leaders
    ? leaders.map((leader, index) => (
        <Fragment key={index}>
          <Box display="flex" alignItems="center" mt={3} mb={2} width="100%">
            <Avatar
              alt={leader.name}
              src={leader.avatarUrl}
              className={classes.avatar}
            />
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
              ml={2}
            >
              <Box display="flex" flexDirection="column">
                <Typography variant="subtitle1">{leader.name}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {leader.position}
                </Typography>
              </Box>
              <Typography variant="subtitle2">
                {leader.totalAwardsEarned}
              </Typography>
            </Box>
          </Box>
          <Divider />
        </Fragment>
      ))
    : null;
}
